var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5263 0H1.78947C0.805263 0 0 0.818182 0 1.81818V14.5455H1.78947V1.81818H12.5263V0ZM11.6316 3.63636L17 9.09091V18.1818C17 19.1818 16.1947 20 15.2105 20H5.35947C4.37526 20 3.57895 19.1818 3.57895 18.1818L3.58789 5.45455C3.58789 4.45455 4.38421 3.63636 5.36842 3.63636H11.6316ZM10.7368 10H15.6579L10.7368 5V10Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconCopy);
export default __webpack_public_path__ + "static/media/menu-icon-copy.41ae3661dc2a126a3927d62d492d1e81.svg";
export { ForwardRef as ReactComponent };